import loadGoogleMapsApi from 'load-google-maps-api';


export default loadGoogleMapsApi({
    key: 'AIzaSyBWGnqd3R6sIBPVR2lSCqZd9L9qprL6SRU',
    libraries: [],
});
